/**
 * @module popupButtons
 */
module.exports = function() {
    const chatBtn = document.querySelector( '.zendesk-btn' );
    const calendlyBtn = document.querySelector( '.calendly-btn' );
    let isChatBtnClicked = false;
    if ( calendlyBtn ) {
        if ( window.innerWidth < 767 ) {
            calendlyBtn.classList.remove( 'd-flex' );
            calendlyBtn.classList.add( 'd-none' );
        } else {
            calendlyBtn.style.left = '20px';
        }
    }
    function handleScroll() {
        if ( window.scrollY > 0 && ! isChatBtnClicked && window.innerWidth > 767 ) {
            chatBtn.classList.remove( 'd-none' );
            chatBtn.classList.add( 'd-flex' );
            if ( calendlyBtn ) {
                calendlyBtn.style.left = '100px';
            }
        }
    }
    function handleClick() {
        isChatBtnClicked = true;
    }
    if ( chatBtn ) {
        chatBtn.addEventListener( 'click', handleClick );
    }
    window.addEventListener( 'scroll', handleScroll );
}; // exports
